import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/views/MainHomePages/LoginPage.vue";

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/LandingPage",
    name: "LandingPage",

    component: () =>
      import(
        /* webpackChunkName: "LandingPage" */ "../views/MainHomePages/LandingPage.vue"
      ),
    children: [
      {
        path: "/Dashboard",
        name: "Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard" */ "../views/ChildHomePages/Dashboard.vue"
          ),
      },
      {
        path: "/Organization",
        name: "Organization",
        component: () =>
          import(
            /* webpackChunkName: "Organization" */ "../views/ChildHomePages/Organization.vue"
          ),
      },
      {
        path: "/QrLots",
        name: "QrLots",
        component: () =>
          import(
            /* webpackChunkName: "QrCodes" */ "../views/ChildHomePages/QrLots.vue"
          ),
      },
      {
        path: "/UserManagement",
        name: "UserManagement",
        component: () =>
          import(
            /* webpackChunkName: "UserManagement" */ "../views/ChildHomePages/UserManagement.vue"
          ),
      },
      {
        path: "/FieldRepository",
        name: "FieldRepository",
        component: () =>
          import(
            /* webpackChunkName: "FieldRepository" */ "../views/ChildHomePages/FieldRepository.vue"
          ),
      },
      {
        path: "/AssetsRetireReasons",
        name: "AssetsRetireReasons",
        component: () =>
          import(
            /* webpackChunkName: "AssetsRetireReasons" */ "../views/ChildHomePages/AssetsRetireReasons.vue"
          ),
      },
      {
        path: "/IndustryTypes",
        name: "IndustryTypes",
        component: () =>
          import(
            /* webpackChunkName: "IndustryTypes" */ "../views/ChildHomePages/IndustryTypes.vue"
          ),
      },
      {
        path: "/Modules",
        name: "Modules",
        component: () =>
          import(
            /* webpackChunkName: "Modules" */ "../views/ChildHomePages/Modules.vue"
          ),
      },
      {
        path: "/Packages",
        name: "Packages",
        component: () =>
          import(
            /* webpackChunkName: "Packages" */ "../views/ChildHomePages/Packages.vue"
          ),
      },
      {
        path: "/PlanSettings",
        name: "Plan Settings",
        component: () => import("../views/ChildHomePages/PlanSettings.vue")
      },
      {
        path: '/ContactHistory',
        name: "Contact History",
        component: () => import('../views/ChildHomePages/ContactHistory.vue')
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
